export default "__VITE_ASSET__910646c9__"